export const defaultLinkStyle = "text-brand-600 hover:underline";
